module.exports = __webpack_public_path__ + "static/media/teams-header.0a6be767.svg";